import React from "react";
import styled from "styled-components";

const Audm = ({ src }) => {
  return (
    <StyledAudm>
      <iframe height="90" width="100%" sandbox="allow-scripts allow-same-origin allow-popups" title="Embedded Frame" src={src} allowfullscreen=""></iframe>
    </StyledAudm>
  );
};
export default Audm;

const StyledAudm = styled.aside`
  position: relative;
  margin: 0 auto calc(2.5 * var(--text-size));
  padding-bottom: calc(1.5 * var(--text-size));
  max-width: var(--text-max-width);
  &::after {
    content: '';
    position: absolute;
    height: 1px;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: currentColor;
    opacity: 0.2;
    }
  iframe {
    border: 0;
    display: block;
    margin: 0;
    filter: saturate(0);
  }
`